module.exports = __webpack_public_path__ + "img/rubbish-bin.51c31125.svg";